"use client"; // This marks the component as a Client Component

import { Inter } from "next/font/google";
import ConfigProvider from "../components/ConfigProvider";
import FormDataProvider from "../components/FormDataProvider";
import ThemeProviderComponent from '../components/ThemeProviderComponent';
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { AuthProvider } from "../components/AuthProvider";
import "./globals.css";
import { Suspense } from "react";

const inter = Inter({ subsets: ["latin"] });

// Define your RootLayout
export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (
    <html lang="en">
      <head>
        <title>Electronic Form</title>
        <meta name="description" content="Electronic Form (eForm)" />
      </head>
      <body className={inter.className}>
        <ConfigProvider>
          <Suspense fallback={<div>Loading application...</div>}>
            <AuthProvider>
              <FormDataProvider>
                <ThemeProviderComponent>
                  <Header />
                  {children}
                  <Footer version="1.0.0" />
                </ThemeProviderComponent>
              </FormDataProvider>
            </AuthProvider>
          </Suspense>
        </ConfigProvider>
      </body>
    </html>
  );
}